import { createFeatureSelector, createSelector } from '@ngrx/store';
import { IMainDataState, mainData } from '@app/main/main-screen/store/main-data/main-data.state';
import {
  selectMainDate,
  selectMainProjectId,
  selectMainSharedSelectionIsLoading,
  selectMainViewMode,
} from '@app/main/main-screen/store/main-selection/main-shared-selection/main-shared-selection.selectors';
import {
  selectMainAreaId,
  selectMainProjectSelectionIsLoading,
} from '@app/main/main-screen/store/main-selection/main-project-selection/main-project-selection.selectors';

export const selectMainDataState = createFeatureSelector<IMainDataState>(mainData);

export const selectMainDataIsLoaded = createSelector(
  selectMainDataState,
  (state: IMainDataState): boolean => state.loaded
);

export const selectMainDataIsLoading = createSelector(
  selectMainDataState,
  (state: IMainDataState): boolean => state.loading
);

export const selectGlobalMainDataIsLoading = createSelector(
  selectMainDataState,
  selectMainSharedSelectionIsLoading,
  selectMainProjectSelectionIsLoading,
  selectMainDate,
  selectMainViewMode,
  selectMainProjectId,
  selectMainAreaId,
  (
    state: IMainDataState,
    mainSharedSelectionIsLoading,
    mainProjectSelectionIsLoading,
    mainDate,
    mainViewMode,
    mainProjectId,
    mainAreaId
  ): boolean =>
    state.loading ||
    mainSharedSelectionIsLoading ||
    mainProjectSelectionIsLoading ||
    mainDate !== state.request?.date ||
    mainViewMode !== state.request?.viewMode ||
    mainProjectId !== state.request?.projectId ||
    mainAreaId !== state.request?.areaId
);

export const selectGlobalMainDataIsLoaded = createSelector(
  selectGlobalMainDataIsLoading,
  (isLoading): boolean => !isLoading
);

export const selectPrevMainDataRequest = createSelector(selectMainDataState, state => state.request);
